// Example: To understand how it works
import { GetterTree } from 'vuex';

import State from './state';
import RootState from '../../state'

// GetterTree<[current state], [root state]>
const getters: GetterTree<State, RootState> = {
	/*
	 * Example for using getters.
	 */
    //someting(state: State): string {
    //    return state.single_auth;
    //}
};

export default getters;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/cities/getters.ts